(function () {
  var gated = (window.theme && window.theme.beforeReleaseProducts) || {};
  if (!Object.keys(gated).length) return;

  var HANDLE_RE = /\/products\/([^/?#]+)/;
  var BUTTON_SELECTOR =
    '.swym-storefront-layout-grid-item-add-to-cart-button, [data-action="add-to-cart"]';

  function findHandle(button) {
    var scope = button.closest('[class*="swym-storefront-layout-grid-item"]') || button.parentElement;
    var hops = 0;
    while (scope && hops < 6) {
      var link = scope.querySelector('a[href*="/products/"]');
      if (link) {
        var m = link.getAttribute('href').match(HANDLE_RE);
        if (m) return decodeURIComponent(m[1]);
      }
      scope = scope.parentElement;
      hops++;
    }
    return null;
  }

  function gateButton(button) {
    if (button.dataset.releaseGated === 'true') return;

    var handle = findHandle(button);
    if (!handle || !gated[handle]) return;

    button.dataset.releaseGated = 'true';
    button.disabled = true;
    button.setAttribute('disabled', 'disabled');
    button.classList.add('before-release-btn');
    button.style.pointerEvents = 'none';
    button.textContent = gated[handle];

    button.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      },
      true
    );
  }

  function scan(root) {
    root.querySelectorAll(BUTTON_SELECTOR).forEach(gateButton);
  }

  scan(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(BUTTON_SELECTOR)) gateButton(node);
        if (node.querySelectorAll) scan(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
